document.addEventListener('DOMContentLoaded', () => {
  const $navbarBurgers = Array.prototype.slice.call(
    document.querySelectorAll('.navbar-burger'), 0
  );

  /**
   * Closes all navbar menus and resets their burger buttons.
   */
  const closeAllMenus = () => {
    $navbarBurgers.forEach(burger => {
      const $target = document.getElementById(burger.dataset.target);
      burger.classList.remove('is-active');
      $target.classList.remove('is-active');
    });
  };

  $navbarBurgers.forEach(el => {
    el.addEventListener('click', () => {
      const $target = document.getElementById(el.dataset.target);
      el.classList.toggle('is-active');
      $target.classList.toggle('is-active');
    });
  });

  // Menü schliessen, wenn ein Navigationspunkt angeklickt wird.
  document.querySelectorAll('.navbar-menu .navbar-item').forEach(item => {
    item.addEventListener('click', () => {
      closeAllMenus();
    });
  });

  // Menü schliessen, wenn ausserhalb des Navbars geklickt wird.
  document.addEventListener('click', (e) => {
    const insideNavbar = e.target.closest('.navbar-wrapper');
    if (insideNavbar === null) {
      closeAllMenus();
    }
  });

  // Menü schliessen, wenn ESC gedrückt wird.
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeAllMenus();
    }
  });
});
